import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Typography,
} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useCreateUserClients } from 'features/auth/use-cases/create-user';
import { useDropDownFlag } from 'features/new-clients/use-cases/drop-down';
import { Fragment, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';

const { Title } = Typography;

export const SignupViewPage = () => {
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { mutate, isLoading } = useCreateUserClients();
  const { data: Industry } = useDropDownFlag('Industry');
  const { data: city } = useDropDownFlag('city');
  const { data: Subscription } = useDropDownFlag('Subscription');
  const navigate = useNavigate();

  const handleOk = () => {
    setIsModalVisible(false);
    navigate(ROUTES.LOGIN);
  };

  const onFinish = (formdata: any) => {
    try {
      const formData = new FormData();
      formData.append('LoggedInUserId', '');
      formData.append('ClientName', formdata.clientname);
      formData.append('Email', formdata.Email);
      formData.append('PhoneNumber', formdata.PhoneNumber);
      formData.append('IndustryId', formdata.IndustryId);
      formData.append('BusinessName', formdata.businessname);
      formData.append('BusinessWebsite', formdata.businesswebsite);
      formData.append('Address', formdata.Address);
      formData.append('CityId', formdata.CityId);
      formData.append('Description', formdata.Description);
      formData.append('SubscriptionId', formdata.SubscriptionId);
      formData.append('SubCategoryAccess', true as any);
      formData.append('SendMailAccess', true as any);
      formData.append('file', '');
      formData.append('ServiceListTemp', '');

      mutate(formData, {
        onSuccess: (data: any) => {
          if (data?.rs == 2) {
            message.error(data?.rm);
          } else {
            form.resetFields();
            setIsModalVisible(true);
          }
        },
      });
    } catch (error) {
      console.error('Error creating user:', error);
    }
  };

  return (
    <Fragment>
      <Form form={form} layout='vertical' onFinish={onFinish}>
        <Row gutter={24}>
          <Col xs={24} lg={12}>
            <Form.Item
              label='Client Name'
              name='clientname'
              rules={[{ required: true, message: 'Name is required' }]}
            >
              <Input placeholder='Enter a Client Name' />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label='Business Name'
              name='businessname'
              rules={[{ required: true, message: 'Business Name is required' }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label='Industry'
              name='IndustryId'
              rules={[{ required: true, message: 'Industry is required' }]}
            >
              <Select
                placeholder='Please Select'
                allowClear
                options={Industry?.data?.rc.map((item: any) => ({
                  value: item.value,
                  label: item.text,
                }))}
              />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label='Business Website'
              name='businesswebsite'
              rules={[
                { required: true, message: 'Business website is required' },
              ]}
            >
              <Input placeholder='Enter Business Website' />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label='City'
              name='CityId'
              rules={[{ required: true, message: 'City is required' }]}
            >
              <Select
                placeholder='Please Select'
                allowClear
                options={city?.data?.rc.map((item: any) => ({
                  value: item.value,
                  label: item.text,
                }))}
              />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label='Address'
              name='Address'
              rules={[{ required: true, message: 'Address is required' }]}
            >
              <Input placeholder='Location' />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label='Phone Number'
              name='PhoneNumber'
              rules={[{ required: true, message: 'Phone number is required' }]}
            >
              <Input
                placeholder='Enter Phone Number'
                onKeyPress={(e) => {
                  const isNumber = /^[0-9]$/.test(e.key);
                  if (!isNumber) e.preventDefault();
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} lg={12}>
            <Form.Item
              label='Email'
              name='Email'
              rules={[
                { required: true, message: 'Email is required' },
                {
                  type: 'email',
                  message: 'Please enter a valid email address',
                },
              ]}
            >
              <Input placeholder='Enter Email' />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Form.Item
              label='Description'
              name='Description'
              rules={[{ required: true, message: 'Description is required' }]}
            >
              <TextArea rows={4} placeholder='Description' />
            </Form.Item>
          </Col>

          <Col xs={24}>
            <Title level={4}>Subscription Information</Title>
            <Row gutter={24}>
              <Col xs={24} lg={24}>
                <Form.Item
                  label='Subscription'
                  name='SubscriptionId'
                  rules={[
                    { required: true, message: 'Subscription is required' },
                  ]}
                >
                  <Select
                    options={Subscription?.data?.rc.map((item: any) => ({
                      value: item.value,
                      label: item.text,
                    }))}
                    placeholder='Please Select'
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          <Col xs={24} style={{ textAlign: 'right' }}>
            <Form.Item>
              <Button type='primary' htmlType='submit' loading={isLoading}>
                Signup
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Modal
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleOk}
        centered
        title='Account Created'
        okText='Go to Login'
        cancelText='Cancel'
      >
        <p>Your account has been created successfully!</p>
      </Modal>
    </Fragment>
  );
};
